export type EditorialChecklistProgress = {
  completed: number;
  total: number;
};

export function countEditorialChecklistProgress(
  flags: boolean[],
): EditorialChecklistProgress {
  return {
    completed: flags.filter(Boolean).length,
    total: flags.length,
  };
}
